// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2IKyx","detailsBorder":"styles_detailsBorder__2yku8"};